// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"260":"2ab3766a","2806":"53f9fbd1","6901":"68579c7b","9209":"fb447f90"}[chunkId] + ".chunk.css";
};